import { environment } from '../../environments/environment'

type CurrencyType = '₹' | '$' | '€'

export const currency: CurrencyType = '$'

export const currentYear = new Date().getFullYear()

export const credits = {
  website: 'https://www.sphynch.com/',
  name: 'Sphynch',
  platformName: 'ECommerce',
}

export const gridPageSizes = [5,10,25,50]

export const basePath: string = '/'

export const apiSettings = {
  // Server addresses live in src/environments/ — the azure build configuration swaps the file so
  // the same code points at local servers in dev and the deployed platform on cloud.
  baseApiUrl: environment.oauthIssuer,
  ecommerceApiUrl: environment.ecommerceApiBaseUrl,
  baseApiVersion: 'api/v1',
  ecommerceApiVersion: 'api/v1',
  fallbackErrorMessage: 'An unhandled exception occured.',
}

export const OAuthSettings = {
  // Identity is both the API host `baseApiUrl` points at and the OAuth2 issuer — one value, one source.
  issuer: apiSettings.baseApiUrl,
  redirectUriPath: '',
  clientId: '7F4C2A98-51D6-4B0E-B2A7-9E8D1C63F5A2',
  scope: 'openid profile offline_access ecommerce_launchpad_api',
  responseType: 'code',
  // 'remoteOnly': a remote Identity server must be HTTPS, but a localhost redirect/issuer may stay HTTP.
  requireHttps: 'remoteOnly' as const,
}
